import { useReferralInvites } from './useReferralInvites'

export function useHasMultipleReferralInvites() {
  const invites = useReferralInvites()

  return invites['hydra:totalItems'] > 1
}
